<!-- do not change this without changing it in both the journeys and calculators! -->

<template>
	<div class="col-auto custom-tooltip-wrapper p-0">
		<div class="custom-tooltip">
			<div
				tabindex="0"
				class="tooltip-toggle"
				@mouseover="show"
				@mouseleave="hide"
				@keyup.tab="show"
				@keydown.tab="hide"
			>
				?
			</div>

			<transition name="fade">
				<div
					v-if="visible"
					class="tooltip-content"
					v-html="content"
				/>
			</transition>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		content: String
	},
	data() {
		return {
			visible: false,
		}
	},
	emits: ['closeOtherTooltips'],
	methods: {
		closePreviousToolTips(index) {
			this.$emit('closeOtherTooltips', index);
		},

		show() {
			this.visible = true;
		},

		hide() {
			this.visible = false;
		}
	}
};

</script>
